import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import PagerProps from './PagerProps'

import Messages from './Messages'

export default {
    props: PagerProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent, 
        KendoBaseDatasourceComponent,
        Messages
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoPager(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoPager()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-listview-vue-wrapper/src/KendoPager/KendoPagerMixin.js